import { Store } from 'redux';

import { ErrorTypes, LoadDataReject } from 'types/load-data-reject-reason';
import {
	fetchRatingRequest,
	selectConfiguratorsNetwork,
	selectRatingNetwork,
} from 'containers/configurators-listing';

export const ConfiguratorsRatingLoadData = (store: Store) =>
	new Promise<void>((resolve, reject: LoadDataReject) => {
		const unsub = store.subscribe(() => {
			const configuratorsNetwork = selectConfiguratorsNetwork(store.getState());

			if (configuratorsNetwork.isFetched && configuratorsNetwork.isFailed) {
				unsub();
				return reject({
					type: ErrorTypes.DATA,
					message: 'No configurators data to fetch rating',
				});
			}

			const ratingNetwork = selectRatingNetwork(store.getState());

			if (
				configuratorsNetwork.isFetched &&
				!ratingNetwork.isFetched &&
				!ratingNetwork.isFetching
			) {
				store.dispatch(fetchRatingRequest());
			}

			if (ratingNetwork.isFetched) {
				unsub();

				if (ratingNetwork.isFailed) {
					console.error('Configurators rating was not fetched');
					console.error(ratingNetwork.error);
				}

				// так как ошибка фетча рейтинга конфигураторов не должна влиять на сборку страницы
				// резолвим промис в любом случае
				return resolve();
			}
		});
	});
